import { useTranslation } from "react-i18next";
import { WhatsappLogo } from "@phosphor-icons/react";
import { waLink } from "@/lib/api";

export const WhatsAppFloat = () => {
  const { t } = useTranslation();
  return (
    <a
      data-testid="whatsapp-float"
      href={waLink(t("whatsapp.generic"))}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("whatsapp.floatLabel")}
      className="wa-pulse fixed bottom-6 right-6 z-[80] w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-2xl hover:scale-110 transition-transform duration-300"
    >
      <WhatsappLogo size={28} weight="fill" />
    </a>
  );
};
